export default "__VITE_ASSET__859125f2__"